import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { GenericLinkComponentService, GenericLinkModule, NavigationNode } from '@spartacus/storefront';
import { TARGET_TYPE } from '../../../../../../core/models/link.model';
import { MenuMobileService } from '../../header/menu-mobile.service';

@Component({
  selector: 'nav-label',
  standalone: true,
  imports: [CommonModule, GenericLinkModule],
  templateUrl: './nav-label.component.html',
  styleUrl: './nav-label.component.scss',
})
export class NavLabelComponent {
  TARGET_TYPE = TARGET_TYPE;
  @Input() node!: NavigationNode;
  @Input() classContainer: string = '';

  constructor(
    private winRef: WindowRef,
    private genericLinkComponentService: GenericLinkComponentService,
    private menuMobileService: MenuMobileService,
  ) {}

  isCurrentUrl(node: NavigationNode) {
    const currentURL = this.winRef.isBrowser() ? this.winRef.location.pathname : '';
    const nodeURL = Array.isArray(node.url) ? node.url.join(', ') : node.url || '';
    return currentURL === nodeURL;
  }

  isExternal(url: string | string[]) {
    return this.genericLinkComponentService.isExternalUrl(url);
  }

  checkUrlAndCloseMenu() {
    if (this.node.url === this.winRef.location.pathname) {
      this.menuMobileService.close();
    }
  }
}
